import { useCallback } from "react";
import { removeMADetailFromParentRoll } from "../services/productionService";

const useRemoveMANumberByParentRollId = (callMessage) => {
    const processIndent = useCallback(async (selectedMode, editSalaryStructureID, requestBody) => {
        try {


            const successMessage = selectedMode === 0
                ? (editSalaryStructureID !== 0
                    ? 'MA Removed Successfully'
                    : 'MA Removed Successfully')
                : 'Issued indent Approved Successfully';

            // Await the API response
            const data = await removeMADetailFromParentRoll(requestBody);

            if (data?.length > 0) {
                callMessage('info', successMessage, 'info');
            } else {
                callMessage('error', 'No data received from API', 'Error');
            }
        } catch (error) {
            callMessage('error', error.message || 'An unexpected error occurred', 'Error');
        }
    }, [callMessage]);

    return { processIndent };

}
export default useRemoveMANumberByParentRollId;



